import Config from "@/config";
import store from "@/store";
import {jointContexts} from "@/utils/pick";

/**
 * Применяет queryMap действия роута (meta.actions[].queryMap) к query URL:
 * переименовывает query-аргументы в параметры запроса, например {tag: "tagId"} (?tag=x -> tagId=x).
 * @param {object} query query-аргументы URL
 * @param {object} [queryMap] соответствие {имя в URL: имя параметра запроса}
 * @returns {object} новый объект параметров
 */
export const mapRouteQuery = (query, queryMap) => {
    const res = {...query};
    Object.entries(queryMap || {}).forEach(([queryKey, paramKey]) => {
        if (typeof res[queryKey] === "undefined") return;
        res[paramKey] = res[queryKey];
        delete res[queryKey];
    });
    return res;
};

export const parseContextIds = (str) => {
    if (!str) return {};
    let rootContextId, contextId;
    if (str.length === Config.AUTH_LENGTH * 2) {
        rootContextId = str.substring(0, Config.AUTH_LENGTH);
        contextId = str.substring(Config.AUTH_LENGTH);
    } else {
        rootContextId = contextId = str;
    }
    return {
        rootContextId,
        contextId,
    }
}

/**
 * Returns root context from current context.
 * @returns {null|*}
 */
export const obtainRootContext = () => {
    /*if (!area) area = store.state.session.area;
    if (!context) context = store.state.page.context.item;
    if (!context) return null;*/

    const context = store.state.page.context;
    return context.parents?.length ? context.parents[0] : context.item;

    /*let {rootContextId, contextId} = parseContextIds(context.contextId);
    //console.log("rootContextId, contextId", rootContextId, contextId);
    //if ( rootContextId === contextId ) return jointContexts(area).find(el => el.contextId === rootContextId);
    const allContexts = jointContexts(area);
    const c = allContexts.find(el => el.contextId === rootContextId);
    if ( !c ) return null;
    //console.log("C", c);
    if (c.isPick || c.isGroup || c.isUser) return c;
    /!*if (c.isTopic || c.isTag) {
        const g = allContexts.find(el => el.id === c.groupId);
        //console.log("G", g);
        return g;
    }*!/
    return null;*/
}